import {ApiServices} from "./api.services.mjs";

var url = 'https://api-adresse.data.gouv.fr/search?q=Avenue+André+Reinson+Bordeaux';

/* 
var delayManager = {
	lastTimestamp : 0,
	minPeriod : 300, 
	// set minPeriod(minPeriod){
		// this._minPeriod = minPeriod;
	// }
	get delay(){
		var currentTimestamp = new Date().getTime();
		var minPeriod = this.minPeriod;
		var delay = (currentTimestamp - this.lastTimestamp) - minPeriod;
		if (delay>0) delay = 0;
		this.lastTimestamp = currentTimestamp;
		return delay; 
	},
	renderTimestamp(timestamp){
		var d = new Date(timestamp);
		var str = `${d.getHours()}:${d.getMinutes()}:${d.getSeconds()}`;
		return str; 
	}
}; */






class RequestManager{
	constructor(){
		
		
		
		// =======
		// private
		// -------
		// setCacheServices and cache (external functions) 
		
		

		
		
		// =======
		// Private
		// -------
		
		var rateLimiter = {
			currentTimer : undefined, 
			minPeriod : 300, 
			run : function(f){
				if (this.currentTimer) clearTimeout(this.currentTimer);
				this.currentTimer = setTimeout(function(){
					f();
				}, this.minPeriod);
			}
		};
		
		// =========
		// protected 
		// ---------
		Object.defineProperty(this,'rateLimiter',{
			value : rateLimiter,
			enumerable: true
		});	
		
	}
	
	request(url, response){
		/* init */
		/* request cache */
		/* request api */
		this.apiRequest(url, response);
	}
	
	apiRequest(url, response){
		this.rateLimiter.run(function(){
			var currentTime = new Date();
			// console.log(`${currentTime.getHours()}:${currentTime.getMinutes()}:${currentTime.getSeconds()}`);
			ApiServices.request(url, response);
		});
	}
	
}

/*
config.setCacheServices = 
config.minPeriod = 500;

delay = (currentT - lastT) - minperiod 
if (delay>0) delay = 0
setTimetout(f,delay)
lastT=currentT  -> this.recordTimestamp()

Object Chronos
*/

export var requestManager = new RequestManager();

